export default "__VITE_ASSET__cmf3ROnO__"